import { daysBetween, todayIso } from '../../shared/data/common';

// Plans, prices and benefits come live from /api/insurance; these are general policy terms.
export const exclusions = [
  'Pre-existing medical conditions, unless the emergency is life-threatening',
  'Travel against medical advice or for the purpose of medical treatment',
  'Injuries under the influence of alcohol or drugs, or from self-harm',
  'War, nuclear risks and participation in civil unrest',
  'Losses from baggage left unattended in a public place',
];

/** Refund estimate for demo bookings saved before live insurance; live policies are quoted by the API. */
export function insuranceRefund(booking) {
  const days = daysBetween(todayIso(), booking.travelDate);
  if (days >= 1) return { amount: Math.max(0, booking.fare.total - 100), note: 'Cancelled before policy start — ₹100 processing fee.' };
  return { amount: 0, note: 'Policy is already active — cannot be cancelled online.' };
}
